'use client';

import React, { useState, useEffect } from 'react';
import { ChevronRight } from 'lucide-react';

// Profile menu data array - only Logout visible
const profileMenuData = [
  //  {
  //   id: 1,
  //   icon: <ChevronRight className="w-4 h-4" />,
  //   text: 'Edit Profile',
  //   href: '/profileview',
  // },
  // {
  //   id: 2,
  //   icon: <ChevronRight className="w-4 h-4" />,
  //   text: 'Saved Items',
  //   href: '/saved-items',
  // },
  // {
  //   id: 3,
  //   icon: <ChevronRight className="w-4 h-4" />,
  //   text: 'Subscriptions',
  //   href: '/subscriptions',
  // },
  {
    id: 4,
    icon: <ChevronRight className="w-4 h-4" />,
    text: 'Logout',
    href: '/logout',
  },

];

interface ProfileItemProps {
  icon: React.ReactNode;
  text: string;
  href: string;
  onClick?: (e: React.MouseEvent) => void;
  className?: string;
}

const ProfileItem = ({
  icon,
  text,
  href,
  onClick,
  className = '',
}: ProfileItemProps) => {
  return (
    <a
      href={href}
      onClick={onClick}
      className={`flex items-center justify-between px-4 py-4 text-sm text-808080-700 hover:bg-gray-100 ${className}`}
    >
      <div className="flex items-center text-000000 text-12-english-400">
        <span>{text}</span>
      </div>
      <ChevronRight className="w-4 h-4 text-808080" />
    </a>
  );
};

interface ProfileMenuProps {
  className?: string;
}

const ProfileMenu = ({ className = '' }: ProfileMenuProps) => {
  const [userEmail, setUserEmail] = useState<string>('');

  useEffect(() => {
    const storedEmail = localStorage.getItem('auth_email') || '';
    setUserEmail(storedEmail);
  }, []);

  const firstLetter = userEmail ? userEmail.charAt(0).toUpperCase() : 'U';

  const handleLogout = (e: React.MouseEvent) => {
    e.preventDefault();
    localStorage.removeItem('auth_email');
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');
    window.location.reload();
  };

  return (
    <div className={`bg-FFFFFF w-full ${className}`}>
      <div className="p-4 bg-ECEEF3">
        <div className="flex items-center gap-4">
          <div className="relative w-10 h-10 rounded-full bg-012061 flex items-center justify-center shrink-0">
            <span className="text-white text-16-english-700 font-bold">{firstLetter}</span>
          </div>
          
          <div className="min-w-0">
            <p className="text-14-english-600 text-222222 truncate">{userEmail || 'User'}</p>
          </div>
        </div>
      </div>
      <div className="">
        {profileMenuData.map((item, index) => (
          <div key={item.id} className={index !== profileMenuData.length - 1 ? 'border-b border-DCDCDC' : ''}>
            <ProfileItem
              {...item}
              onClick={item.text === 'Logout' ? handleLogout : undefined}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfileMenu;
